import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ConnectMetaCommerceManagerPage = lazy(
  () => import('~/features/onboarding/pages/connect-meta-commerce-manager-screen'),
);

/** `connectionId` present → edit an existing Meta connection (prefill + PATCH);
 *  absent → the normal create flow. */
const searchSchema = z.object({
  connectionId: z.string().optional(),
});

function ConnectMetaCommerceManagerRouteComponent() {
  const { connectionId } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ConnectMetaCommerceManagerPage connectionId={connectionId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/meta/meta-commerce-manager',
)({
  validateSearch: searchSchema,
  component: ConnectMetaCommerceManagerRouteComponent,
});
